import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';
import PeriodNotice from './PeriodNotice';
import { formatYearMonthLabel } from './utils/historyDateTime';

export default function HistoryPeriodNotice({ yearMonth }) {
  const monthLabel = formatYearMonthLabel(yearMonth);
  const isCurrentMonth = yearMonth === dayjs().format('YYYY-MM');

  return (
    <PeriodNotice>
      Riwayat <strong>Hapus/Set Provinsi Transaksi</strong> ini berlaku untuk{' '}
      {isCurrentMonth ? (
        <>
          <strong>bulan ini ({monthLabel})</strong>.
        </>
      ) : (
        <>
          <strong>bulan {monthLabel}</strong>.
        </>
      )}
    </PeriodNotice>
  );
}

HistoryPeriodNotice.propTypes = {
  yearMonth: PropTypes.string.isRequired,
};
